module.exports = __webpack_public_path__ + "img/nav-btn-1.cd6e9b26.svg";